import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MenuStateService {
  public selectedMenu = new BehaviorSubject<string>('dashboard');

  expandMenu(menu: string) {
    this.selectedMenu.next(menu);
  }
} 